// extracted by mini-css-extract-plugin
export default {"RegistryDetails__skeleton":"RegistryDetails-styles__RegistryDetails__skeleton__jOsr9","RegistryDetails__registryInfo":"RegistryDetails-styles__RegistryDetails__registryInfo__gAtvo"};